import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Storage } from '@ionic/storage';

import { BuilderServiceApi } from "./../../../shared/sdk/services/custom/BuilderService"; // Need Dependency - PageBuilder
import { PageBuilderGlobal } from "./../../providers/global";

import { LoopBackConfig } from "./../../../shared/sdk/lb.config"; // Need Dependency - PageBuilder

import { ApiServiceProvider } from '../api/api-service';

import { Response, Page } from '../../model/page-builder.model';

import _ from 'lodash';
import { AnalyticsProvider } from '../../../providers/analytics/analytics';

@Injectable()
export class PageBuilderSchemaProvider {

  public SFGoAuth: any;
  public SFGoStorage: any;

  public path: any;
  public oldPATHUrl: any;
  public newPATH: boolean = false;
  public newPATHUrl: any;

  // Extension Comment Turbo Console Log
  // Ctrl + Alt + L for display comment
  // Shift + Alt + C for show comment - FOR PRODUCTION
  // Shift + Alt + D for delete
  // Shift + Alt + U for uncomment - FOR DEVELOP

  constructor(
    public _http: Http,
    private _storage: Storage,
    public _builderServiceApi: BuilderServiceApi,
    private _pageBuilderGlobal: PageBuilderGlobal,
    private _apiServiceProvider: ApiServiceProvider,
    private analyticsProvider: AnalyticsProvider,) {
    this.getStorage();
  }

  async getStorage() {
    return new Promise(async (resolve) => {
      await this.getStorageSfGoAuth();
      await this.getStorageSfGoStorage();
      resolve(true);
    });
  }

  async getStorageSfGoStorage(): Promise<any> {
    // console.log("TCL: Get Storage");
    return new Promise((resolve) => {
      this._storage.ready().then(() => {
        this._storage.get('SFGoStorage').then(async (hasil) => {
          if (hasil != null && hasil != undefined) {
            this.SFGoStorage = JSON.parse(hasil);
            if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin) {
              this.oldPATHUrl = this.SFGoStorage.storedPrelogin.GOPATH;
            } else {
              this.oldPATHUrl = this.path;
            }
            let path;
            if (this.SFGoStorage.hasOwnProperty('storedPrelogin') && this.SFGoStorage.storedPrelogin &&
              this.SFGoStorage.storedPrelogin.hasOwnProperty('GOPATHNEW') && this.SFGoStorage.storedPrelogin.GOPATHNEW) {
              // console.log("TCL: New Path Found");
              this.newPATH = true;
              path = this.SFGoStorage.storedPrelogin.GOPATHNEW;
              this.newPATHUrl = path;
            } else {
              // console.log("TCL: New Path Not Found");
              this.newPATH = false;
            }
            // this.newPATHUrl = 'http://localhost:30000' // local nestjs;
            // this.newPATHUrl = 'http://localhost:5000' // local loopback;
            resolve(true);
          }
        });
      });
    });
  }

  getStorageSfGoAuth(): Promise<any> {
    return new Promise(async (resolve) => {
      this.path = LoopBackConfig.getPath();
      // console.log('TCL: ', this.path);
      this._storage.ready().then(() => {
        this._storage.get('SFGoAuth').then(hasil => {
          if (hasil != null && hasil != undefined) {
            this.SFGoAuth = JSON.parse(hasil);
            resolve(true);
          }
        });
      });
    })
  }

  async reloadSchema(position = 'left'): Promise<any> {
    let pageBuilderPages = await this._storage.get("pageBuilderPages");
    try {
      pageBuilderPages = JSON.parse(pageBuilderPages);
    } catch (e) {
      pageBuilderPages = pageBuilderPages;
    }

    let pageBuilderReloadPage;
    if (position === 'left') {
      pageBuilderReloadPage = await this._storage.get("pageBuilderReloadPageLeft");
    } else if (position === 'right') {
      pageBuilderReloadPage = await this._storage.get("pageBuilderReloadPageRight");
    }

    try {
      pageBuilderReloadPage = JSON.parse(pageBuilderReloadPage);
    } catch (e) {
      pageBuilderReloadPage = pageBuilderReloadPage;
    }

    return this.loadSchema(pageBuilderPages, pageBuilderReloadPage);
  }

  async loadSchema(pageBuilderPages, pageId, pageStatic = null, pageParamAsBody?, pageParam?): Promise<any> {
    // console.log("TCL: Load Schema", pageBuilderPages, pageId);
    let version = await this._storage.get("pageBuilderVersion");
    try {
      version = JSON.parse(version);
    } catch (e) {
      version = version;
    }

    let schemaPage;

    // console.log('TCL: check findPageBuilderPagesById', this.findPageBuilderPagesById(pageBuilderPages, pageId));
    if (this.findPageBuilderPagesById(pageBuilderPages, pageId)) {
      // console.log("TCL: Find Id Found",);
      let schema = pageBuilderPages[pageId];
      // console.log('TCL: Version', version);
      if (version && version[pageId]) {
        // console.log("TCL: Version Found");
        if (pageBuilderPages[pageId] && pageBuilderPages[pageId].hasOwnProperty('version') && pageBuilderPages[pageId].version && this.matchVersioning(pageBuilderPages[pageId].version, version[pageId])) {
          // console.log("TCL: Version Match");
          schemaPage = await this.getSchemaStorage(schema, pageStatic, pageParamAsBody, pageParam);
          return schemaPage;
        }
      } else {
        // console.log("TCL: Version Empty");
        schemaPage = await this.getSchemaStorage(schema, pageStatic, pageParamAsBody, pageParam);
        return schemaPage;
      }
    }

    // console.log('TCL: masuk load schema');
    schemaPage = await this.getSchema(pageId, pageStatic, true, pageParamAsBody, pageParam);
    return schemaPage;
  }

  async loadSchemaTwo(pageBuilderPages, pageId): Promise<any> {
    // console.log("TCL: Load Schema Two");
    let version = await this._storage.get("pageBuilderVersion");
    try {
      version = JSON.parse(version);
    } catch (e) {
      version = version;
    }

    let schemaPage;
    if (pageBuilderPages) {
      let schema = pageBuilderPages[pageId];

      if (version && version[pageId]) {
        // console.log("TCL: Version Found");
        console.log(pageBuilderPages[pageId]);
        console.log(version);
        if (pageBuilderPages[pageId] && pageBuilderPages[pageId].hasOwnProperty('version') && pageBuilderPages[pageId].version && this.matchVersioning(pageBuilderPages[pageId].version, version[pageId])) {
          // console.log("TCL: Version Match");
          schemaPage = await this.getSchemaStorage(schema);
          return schemaPage;
        }
      } else {
        // console.log("TCL: Version Empty");
        if (pageBuilderPages[pageId]) {
          // console.log("TCL: Find Id Found");
          schemaPage = await this.getSchemaStorage(schema);
          return schemaPage;
        }
      }
    }
    schemaPage = await this.getSchema(pageId, null, true);
    return schemaPage;
  }

  findPageBuilderPagesById(pageBuilderPages, pageId) {
    if (!_.isEmpty(pageBuilderPages) && pageBuilderPages[pageId]) {
      return true;
    }
    return false;
  }

  matchVersioning(versionPage, versionAPI): boolean {
    console.log(versionPage, versionAPI);
    if (versionPage === versionAPI) {
      return true;
    }
    return false;
  }

  getSchema(pageId, pageStatic?, setStorage = false, pageParamAsBody?, pageParam?): Promise<any> {
    // console.log("TCL: Get Schema");
    return new Promise(async (resolve) => {
      if (pageStatic === true) {
        this._pageBuilderGlobal.getStaticPage(pageId).then(
          async schema_tmp => {
            // console.log("TCL: Schema Static Found");
            let pageSchema = schema_tmp;

            pageSchema.pageOption.pageStatic = true;

            let pageSchemaFinal = JSON.stringify(pageSchema);
            // console.log("TCL: Schema", pageSchemaFinal);

            schema_tmp.pageTypeIdInit = schema_tmp.pageTypeId;

            let schema = {
              status: 'loadSchema',
              pageId: schema_tmp.code,
              pageTitle: schema_tmp.title,
              pageType: schema_tmp.pageTypeId,
              pageTypeInit: schema_tmp.pageTypeIdInit,
              pageSchema: pageSchemaFinal,
              pageFile: schema_tmp.file,
              pageParam: pageParam ? pageParam : [],
              pageIsSub: false,
              userId: this.SFGoAuth.userId,
              static: schema_tmp.staticPage,
              version: schema_tmp.version,
              pageParamAsBody: pageParamAsBody
              // cacheDuration: null,
              // cacheStart: null,
            }

            resolve(schema);
          },
          error => {
            // console.log('Error Get Schema Static', error);
            let schema = {
              status: 'error',
              message: error
            }
            resolve(schema);
          }
        ).catch(error => {
          // console.log('Error Get Schema Static', error);
          let schema = {
            status: 'error',
            message: error
          }
          resolve(schema);
        })
      } else {
        const urlParams = '&pageId=' + pageId;
        this._apiServiceProvider.apiPB('GET', urlParams, null, '/app-page/getPageById', false, true).then(async (response: Response<Page>) => {
          if (response.data) {

            let schema_tmp = response.data;
            // console.log("TCL: Schema By Id Found");
            // console.log("TCL: Schema", schema_tmp);
            let pageSchema = JSON.parse(schema_tmp.schema);

            if (!pageSchema) {
              let schema = {
                status: 'error',
                message: 'Schema not define'
              }
              resolve(schema);
              return;
            }

            schema_tmp.pageTypeIdInit = schema_tmp.pageTypeId;

            if (_.has(pageSchema.pageOption, 'responsivePageView') || _.has(pageSchema.pageOption, 'multiDynamicPage')) {
              if (pageSchema.pageOption.responsivePageView || pageSchema.pageOption.multiDynamicPage) {
                schema_tmp.pageTypeIdInit = 5;
              }
            }

            let date = new Date();
            let dateNow = new Date();

            let duration: any = 0;

            if (schema_tmp.cacheDuration || schema_tmp.cacheDuration === 0) {
              duration = new Date(date.setSeconds(date.getSeconds() + schema_tmp.cacheDuration));
            } else if (schema_tmp.cacheDuration != 0) {
              duration = new Date(date.setSeconds(date.getSeconds() + 300)); // Default Cache Duration
            }

            schema_tmp.cacheDuration = duration;
            schema_tmp.cacheStart = dateNow;

            // console.log("TCL: Cache Duration Start", schema_tmp.cacheStart);
            // console.log("TCL: Cache Duration End", schema_tmp.cacheDuration);
            // console.log("TCL: DateNow", dateNow);

            let schema = {
              status: 'loadSchema',
              pageId: schema_tmp.code,
              pageTitle: schema_tmp.title,
              pageType: schema_tmp.pageTypeId,
              pageTypeInit: schema_tmp.pageTypeIdInit,
              pageSchema: schema_tmp.schema,
              pageFile: schema_tmp.file,
              pageParam: pageParam ? pageParam : [],
              pageIsSub: false,
              userId: this.SFGoAuth.userId,
              static: schema_tmp.staticPage,
              version: schema_tmp.version,
              cacheStart: schema_tmp.cacheStart,
              cacheDuration: schema_tmp.cacheDuration,
              pageParamAsBody: pageParamAsBody
            }

            // console.log("SchemaService",schema);

            if (setStorage) {
              // console.log("TCL: Set Storage State Page");
              let pageBuilderPages = await this._storage.get("pageBuilderPages");

              try {
                pageBuilderPages = JSON.parse(pageBuilderPages);
              } catch (e) {
                pageBuilderPages = pageBuilderPages;
              }

              if (!pageBuilderPages) pageBuilderPages = {};

              // console.log('TCL: cek set', pageBuilderPages[schema_tmp.code])
              if (pageBuilderPages[schema_tmp.code] === null || pageBuilderPages[schema_tmp.code] === undefined || !pageBuilderPages[schema_tmp.code]) {
                // console.log('TCL: Masuk set', pageBuilderPages[schema_tmp.code])
                pageBuilderPages[schema_tmp.code] = schema;
                // console.log('TCL: final set', pageBuilderPages);
                this._storage.set('pageBuilderPages', JSON.stringify(pageBuilderPages));
              }
            }

            resolve(schema);
          } else {
            // console.log('Error Get Schema By Id');
            let schema = {
              status: 'error',
              message: 'Empty Data'
            }
            resolve(schema);
          }
        }, error => {
          // console.log('Error Get Schema By Id', error);
          let schema = {
            status: 'error',
            message: error
          }
          resolve(schema);
        });
      }
    });
  }

  getSchemaStorage(schema_tmp, pageStatic?, pageParamAsBody?, pageParam?): Promise<any> {
    return new Promise(async (resolve) => {
      // console.log("TCL: Storage Schema By Id Found");

      // GA track screen to send google analytics
      this.analyticsProvider.trackView(schema_tmp.pageTitle)

      let pageSchema = JSON.parse(schema_tmp.pageSchema);
      // console.log('TCL: ', pageSchema);

      schema_tmp.pageTypeIdInit = schema_tmp.pageTypeId;
      if (_.has(pageSchema.pageOption, 'responsivePageView') || _.has(pageSchema.pageOption, 'multiDynamicPage')) {
        if (pageSchema.pageOption.responsivePageView || pageSchema.pageOption.multiDynamicPage) {
          schema_tmp.pageTypeIdInit = 5;
        }
      }

      let dateNow = new Date();
      // console.log("TCL: Cache Duration Start", schema_tmp.cacheStart);
      // console.log("TCL: Cache Duration End", schema_tmp.cacheDuration);
      // console.log("TCL: DateNow", dateNow);

      // console.log("TCL: Duration Expired ?", new Date(schema_tmp.cacheDuration) < dateNow);
      if (schema_tmp.cacheDuration && (new Date(schema_tmp.cacheDuration) < dateNow)) {
        // console.log("TCL: Get Schema Again, Cache Expired")
        this.getSchema(schema_tmp.pageId, pageStatic, true, pageParamAsBody, pageParam);
      }

      let schema = {
        status: 'storage',
        pageId: schema_tmp.pageId,
        pageTitle: schema_tmp.pageTitle,
        pageType: schema_tmp.pageType,
        pageTypeInit: schema_tmp.pageTypeIdInit,
        pageSchema: schema_tmp.pageSchema,
        pageFile: schema_tmp.pageFile,
        pageParam: pageParam ? pageParam : [],
        pageIsSub: false,
        userId: this.SFGoAuth.userId,
        static: schema_tmp.staticPage,
        version: schema_tmp.version,
        cacheDuration: schema_tmp.cacheDuration,
        cacheStart: schema_tmp.cacheStart,
        pageParamAsBody: pageParamAsBody
      }
      // console.log("SchemaService",schema);

      let pageBuilderPages = await this._storage.get("pageBuilderPages");

      try {
        pageBuilderPages = JSON.parse(pageBuilderPages);
      } catch (e) {
        pageBuilderPages = pageBuilderPages;
      }

      if (!pageBuilderPages) pageBuilderPages = {};
      if (pageBuilderPages[schema_tmp.pageId] != null && pageBuilderPages[schema_tmp.pageId] != undefined) {
        pageBuilderPages[schema_tmp.pageId] = schema;
        this._storage.set('pageBuilderPages', JSON.stringify(pageBuilderPages));
      }

      resolve(schema);
    })
  }
}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/schema/schema-service.ts